import {
  AlertWithIllustration,
  Props as AlertWithIllustrationProps,
} from "./AlertWithIllustration";

import { IllustrationName } from "Constants/constants";
import React from "react";
import { AlertType } from ".";
import { AccessibleCallUsMessage } from "../AccessibleCallUsMessage";

export type Props = Omit<
  AlertWithIllustrationProps,
  "illustrationName" | "iconName" | "alertType"
>;

export const ContactUsAlert = ({
  children = <AccessibleCallUsMessage />,
  ...rest
}: Props): React.ReactElement => {
  return (
    <AlertWithIllustration
      alertType={AlertType.CONTACT_US_ALERT}
      illustrationName={IllustrationName.CUSTOMER_SERVICE_WOMAN}
      {...rest}
    >
      {children}
    </AlertWithIllustration>
  );
};
